import _defineProperty from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/defineProperty";
import classnames from 'classnames2';
import React from 'react';
import { Icon } from '../Icon';
import styles from './Key.scss';
export var Key = function Key(_ref) {
  var text = _ref.text,
      variant = _ref.variant,
      complete = _ref.complete,
      dataTest = _ref.dataTest;
  var character = text.toString().trim().slice(0, 2);
  var content;

  if (complete) {
    content = React.createElement(Icon, {
      icon: "form-check",
      className: styles.icon
    });
  } else {
    content = React.createElement("div", {
      className: styles.character
    }, character);
  }

  return React.createElement("div", {
    className: classnames(styles.key, styles[variant], _defineProperty({}, styles.complete, complete)),
    "data-test": dataTest
  }, content);
};
Key.defaultProps = {
  variant: 'neutral',
  complete: false
};